import { render, staticRenderFns } from "./BaseWorkspaceLayout.vue?vue&type=template&id=7827d762&scoped=true&"
import script from "./BaseWorkspaceLayout.vue?vue&type=script&lang=js&"
export * from "./BaseWorkspaceLayout.vue?vue&type=script&lang=js&"
import style0 from "./BaseWorkspaceLayout.vue?vue&type=style&index=0&id=7827d762&lang=scss&scoped=true&"
import style1 from "./BaseWorkspaceLayout.vue?vue&type=style&index=1&id=7827d762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7827d762",
  null
  
)

export default component.exports